import 'angular-material';
import "angular-translate";
import "angular-aria";
import "angular-translate-loader-static-files";
import "./password.style.scss";
import { passwordTextBoxComponent } from "./password.component";
import { DirectiveModule } from "../../directives/directive.module";
import { compareTo } from "../../directives/compareto.directive";
import { ModuleUtils } from "../../../utils/moduleutils";
import { ServicesModule } from "../../services/services.module";

const moduleOptions: ngExtendedType.IModuleOptions = {
    injectModules: ['ngMaterial', 'ngAria', 'ngAnimate', "pascalprecht.translate", ServicesModule.name, DirectiveModule.name],
    name: "UserPasswordTextBox.Module",
    components: { passwordTextBoxComponent },
    directives: { compareTo }
};

export let UserPasswordTextBoxModule = ModuleUtils.CreateModule(moduleOptions);